import { createStore, combineReducers } from 'redux';

import reducerLogin from './reducers/login';

const appReducers = combineReducers({
    login: reducerLogin,
});

export default createStore(appReducers);